import { createContext } from 'react';

// definition of the global variable FastbetCartContext: it is structured into Main.js with useState()
const FastbetCartContext = createContext(null);

export default FastbetCartContext;